import { render, staticRenderFns } from "./AppVideo.vue?vue&type=template&id=20fe1abf&scoped=true&"
import script from "./AppVideo.vue?vue&type=script&lang=js&"
export * from "./AppVideo.vue?vue&type=script&lang=js&"
import style0 from "./AppVideo.vue?vue&type=style&index=0&id=20fe1abf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe1abf",
  null
  
)

export default component.exports